import axios from 'axios';
import moment from 'moment-timezone';

export const getSearcData = (payload) => {
	return axios.post(`/api/get-search-res`, payload);
};

export const getEventDetails = (payload) => {
	return axios.post(`/api/get-event-details`, payload);
};

export const retryForwarding = (payload) => {
	return axios.post(`/api/retry-forwarding`, payload);
};

export const getAllSuggestions = (payload) => {
	return axios.post(`/api/get-all-values`, payload);
};

export const REDACTION_API = (payload, cancelApiToken) => {
	return axios.post(`/api/redaction-mask`, payload, cancelApiToken);
};

export const GET_ELASTIC_RECORDS_API = () => {
	return axios.get(`/api/get-peg-metrics`);
};

export const GET_PREDEFINED_REGEX_API = () => {
	return axios.get(`/api/getPredefinedRegex`);
};

export const GET_PRESIGNED_URL = (payload) => {
	return axios.get(
		`/api/get-minio-preSignedURL?fileName=${payload.fileName}&bucketName=${payload.bucketName}`,
	);
};

export const CREATE_SCOPING_CRON_JOB = async () => {
	try {
		// create scoping cron job
		await axios.get(`/api/create-scoping-cronjob`);
	} catch (error) {
		console.error('Error while creating scoping cron:', error);
	}
};

export const getTimestamp = () => {
	return moment().format(`YYYY-MM-DDTHH:mm:ss`);
};

export const getDateWithTimezone = () => {
	return moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ');
};
